export default __webpack_public_path__ + "media/apps/Configurator/images/BWH-Swirl-30-31da55ad29c5e29598d7e0d073860b95.png";